export default __webpack_public_path__ + "static/breakdown-by-operating-system-dark-mode-24df23b70af03ce70a51836757310e34.png";